/* Show more / show less toggle for the equal-width variant button grid (gift card amounts). */
(() => {
  if (customElements.get('option-grid')) return;

  // ProductOptions replaces the picker's HTML after every variant change,
  // so the expanded state is kept here and reapplied to the new element.
  const expandedGrids = new Map();

  class OptionGrid extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-option-grid-toggle]');
      if (!this.toggle) return;

      // Server-rendered "true" means the selected value is in the hidden part and must stay visible.
      const rendered = this.dataset.expanded === 'true';
      this.setExpanded(rendered || expandedGrids.get(this.id) === true, false);

      this.toggle.addEventListener('click', () => {
        this.setExpanded(this.dataset.expanded !== 'true', true);
      });
    }

    setExpanded(expanded, remember) {
      this.dataset.expanded = expanded;
      this.toggle.setAttribute('aria-expanded', expanded);
      if (remember) expandedGrids.set(this.id, expanded);
    }
  }

  customElements.define('option-grid', OptionGrid);
})();
